import {
  Box,
  HStack,
  Input as ChakraInput,
  InputProps as ChakraInputProps,
} from '@chakra-ui/react'
import React from 'react'

import { Field } from './field'
import { InputGroup } from './input-group'

interface InputProps extends ChakraInputProps {
  leftIcon?: React.ReactNode
  rightIcon?: React.ReactNode
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  function Input(
    { value, leftIcon, rightIcon, fontSize = 'md', ...props },
    ref,
  ) {
    return (
      <InputGroup w="100%" startElement={leftIcon} endElement={rightIcon}>
        <ChakraInput
          ref={ref}
          value={value}
          fontSize={fontSize}
          bgColor="white"
          borderColor="gray.300"
          borderRadius="base"
          _invalid={{
            borderColor: 'var(--error-color)',
          }}
          _focusVisible={{
            borderColor: 'colorPalette.500',
            outlineColor: 'colorPalette.500',
          }}
          {...props}
        />
      </InputGroup>
    )
  },
)

interface CounterInputProps extends ChakraInputProps {
  invalid?: boolean
  label?: React.ReactNode
  helperText?: React.ReactNode
  errorText?: string
  maxLength?: number
  leftIcon?: React.ReactNode
  rightIcon?: React.ReactNode
}

export const CounterInput = React.forwardRef<
  HTMLInputElement,
  CounterInputProps
>(function Input(
  {
    invalid,
    label,
    helperText,
    errorText,
    maxLength,
    value,
    leftIcon,
    rightIcon,
    fontSize = 'md',
    ...props
  },
  ref,
) {
  const counterText = maxLength
    ? `${value ? value.toString().length : '0'} / ${maxLength}`
    : undefined

  return (
    <Field
      gap={0.5}
      invalid={invalid}
      label={label}
      errorText={errorText}
      helperText={helperText}
      counter={counterText}
    >
      <InputGroup w="100%" startElement={leftIcon} endElement={rightIcon}>
        <ChakraInput
          ref={ref}
          value={value}
          bgColor="white"
          borderColor={!invalid ? 'gray.300' : undefined}
          borderRadius="base"
          fontSize={fontSize}
          _focusVisible={{
            borderColor: 'colorPalette.500',
            outlineColor: 'colorPalette.500',
          }}
          {...props}
        />
      </InputGroup>
    </Field>
  )
})

interface TermInputProps {
  helperText?: string
  firstInputProps?: ChakraInputProps
  secondInputProps?: ChakraInputProps
}

export const TermInput = React.forwardRef<HTMLInputElement, TermInputProps>(
  function TermInput({ helperText, firstInputProps, secondInputProps }, ref) {
    return (
      <Field gap={0.5} helperText={helperText}>
        <HStack
          w="100%"
          borderWidth="1px"
          borderColor="gray.300"
          borderRadius="base"
          ref={ref}
          _focusWithin={{
            borderColor: 'colorPalette.500',
            outlineColor: 'colorPalette.500',
            outlineWidth: '1px',
            outlineStyle: 'solid',
          }}
        >
          <ChakraInput
            bgColor="white"
            borderWidth="0px"
            borderRadius="base"
            _focusVisible={{
              outline: 'none',
            }}
            fontSize="md" // 指定される場合はfirstInputPropsで上書きされる
            {...firstInputProps}
          />
          <Box>~</Box>
          <ChakraInput
            bgColor="white"
            borderWidth="0px"
            borderRadius="base"
            _focusVisible={{
              outline: 'none',
            }}
            {...secondInputProps}
          />
        </HStack>
      </Field>
    )
  },
)
